/**
 * Adds a "more" functionality to the filter navigation bar for small desktops and tablets
 */
var resizeTimer;
var marginals;

function init() {
    if ($('.filter-nav.has-dd').length > 0) {
        $(window).on('resize', function (e) {

            clearTimeout(resizeTimer);
            resizeTimer = setTimeout(function () {
                checkItemPositions();
            }, 15);
        });

        addDropdown();
        checkItemPositions();
    }
}

function addDropdown() {
    $('.filter-nav.has-dd').append('<div style="display:none" class="filter-nav__dd"></div>');
    $('.filter-nav.has-dd .filter-nav__items').append('<li style="display:none" class="filter-nav__item filter-nav__item--more"><a href="">More <i class="fa fa-angle-down"></i></a></li>');
    $(document).on('click', '.filter-nav__item--more', function (e) {
        e.preventDefault();
        if ($('.filter-nav.has-dd').hasClass('has-more')) {
            $('.filter-nav.has-dd').removeClass('has-more');
        } else {
            $('.filter-nav.has-dd').addClass('has-more');
        }
    })
}

function checkItemPositions() {
    marginals = [];
    var offset = 100;

    var items_width = $('.filter-nav').outerWidth() - offset;
    var items = $('.filter-nav.has-dd .filter-nav__item');
    $('.filter-nav.has-dd .filter-nav__dd').html('');
    items.each(function (i, el) {
      if (!$(el).hasClass('filter-nav__item--more')) {
        var pos = Math.round($(el).position().left + $(el).outerWidth());
  
        if (pos > items_width) {
          $(el).css('visibility','hidden');
          var cln = $(el).find('a').clone();
          $('.filter-nav.has-dd .filter-nav__dd').append(cln);
          marginals.push($(el).text().trim());
        }else{
          $(el).css('visibility','visible');
        }
      }
    });
  
    if (marginals.length) {
      $('.filter-nav.has-dd .filter-nav__item--more').show();
    } else {
      $('.filter-nav.has-dd .filter-nav__item--more').hide();
      $('.filter-nav.has-dd').removeClass('has-more');
    }
  }

export default {
    init: init
}